import { isUndefined, omitBy } from 'lodash'

import getCurrentDateString from 'common/get-current-date-string'
import { APP, FIELDS, PUBLIC_APP } from 'common/metadata-constants'
import getSessionId from 'common/track-events-session-id'

const metadataToTrackedEvent = (metadata, EventType, options = {}) => {
  let EventData = omitBy(
    {
      id: metadata.id,
      correlationId: metadata.correlationId,
      scid: metadata[FIELDS.SCID],
      careerCode: metadata[FIELDS.CAREER_CODE],
      careerTitle: metadata[FIELDS.CAREER_TITLE],
      carouselKey: metadata[FIELDS.CAROUSEL_KEY],
      carouselItemIndex: metadata[FIELDS.CAROUSEL_ITEM_IDX],
      contentType: metadata[FIELDS.CONTENT_TYPE],
      contentItemId: metadata[FIELDS.COLLEGE_CONTENT_ID],
      contentId: metadata[FIELDS.CONTENT_ID],
      contentSearchTag: metadata[FIELDS.CONTENT_SEARCH_TAG],
      expanded: metadata[FIELDS.COLLEGE_CONTENT_EXPANDED],
      itemNumber: metadata[FIELDS.ITEM_NUMBER],
      location: metadata[FIELDS.LOCATION],
      locationIndex: metadata[FIELDS.LOCATION_INDEX],
      locationKey: metadata[FIELDS.LOCATION_KEY],
      filter: metadata[FIELDS.FILTER],
      currentUrl: metadata[FIELDS.CURRENT_URL],
      searchTerm: metadata[FIELDS.SEARCH_TERM],
      ContentItemWasTargeted: metadata[FIELDS.CONTENT_ITEM_WAS_TARGETED],
      VideoContent: metadata[FIELDS.VIDEO_CONTENT],
      CollegeEventContentFilter: metadata[FIELDS.EVENT_SEARCH_FILTERS],
      SearchTag: metadata[FIELDS.SEARCH_TAG],
      previousUrl: metadata[FIELDS.PREVIOUS_URL],
      MessageId: metadata[FIELDS.MESSAGE_ID],
      SourceClickLocation: metadata[FIELDS.SOURCE_CLICK_LOCATION],
    },
    isUndefined,
  )

  const EventSourceApplication = isUndefined(options.isUnauthed)
    ? metadata[FIELDS.APP]
    : options.isUnauthed
      ? PUBLIC_APP
      : APP
  const trackedEvent = {
    EventType,
    DomainType: metadata[FIELDS.DOMAIN_TYPE],
    EventSourceReferrer: metadata[FIELDS.PAGE],
    EventTimestamp: getCurrentDateString(),
    EventSourceApplication,
    SessionId: getSessionId(EventSourceApplication),
  }
  if (options.additionalData) {
    EventData = omitBy(
      {
        ...EventData,
        ...options.additionalData,
      },
      isUndefined,
    )
  }
  if (options.flat) {
    return {
      ...EventData,
      ...trackedEvent,
    }
  }

  trackedEvent.EventData = EventData
  return trackedEvent
}

export default metadataToTrackedEvent
